import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the profileAmbassador state domain
 */

const selectProfileAmbassadorDomain = (state) =>
  state.get("profileAmbassador", initialState)

/**
 * Other specific selectors
 */

export const makeSelectLoadingPlans = () =>
  createSelector(selectProfileAmbassadorDomain, (state) =>
    state.get("loadingPlans")
  )

export const makeSelectPlans = () =>
  createSelector(selectProfileAmbassadorDomain, (state) => state.get("plans"))

export const makeSelectAmbassador = () =>
  createSelector(selectProfileAmbassadorDomain, (state) =>
    state.get("ambassador")
  )

export const makeSelectFilter = () =>
  createSelector(selectProfileAmbassadorDomain, (state) => state.get("filter"))

export const makeSelectDivisions = () =>
  createSelector(selectProfileAmbassadorDomain, (state) =>
    state.get("divisions")
  )

export const makeSelectCountActionPlans = () =>
  createSelector(selectProfileAmbassadorDomain, (state) =>
    state.get("count_action_plans")
  )

export const makeSelectLoadingPhoto = () =>
  createSelector(selectProfileAmbassadorDomain, (state) =>
    state.get("loadingPhoto")
  )

export const makeSelectLeaderTeam = () =>
  createSelector(selectProfileAmbassadorDomain, (state) =>
    state.get("leader_team")
  )

export const makeSelectCurrentUserCanAction = () =>
  createSelector(selectProfileAmbassadorDomain, (state) =>
    state.get("current_user_can_action")
  )

/**
 * Default selector used by ProfileAmbassador
 */

const makeSelectProfileAmbassador = () =>
  createSelector(selectProfileAmbassadorDomain, (substate) => substate.toJS())

export default makeSelectProfileAmbassador
export { selectProfileAmbassadorDomain }
